import {config} from "../config";

type PreloadResponse = {
    data?: Array<string[]>;
};

export const Preloader = {

    load(response?: PreloadResponse) {

        if (!Array.isArray(response?.data)) return;

        const basePaths = ['/static/media', '/img'];

        // @ts-ignore
        response.data.forEach((group, index) => {
            if (!Array.isArray(group) || !group.length) return;

            const basePath = basePaths[index];
            if (!basePath) return;

            group.forEach(path => {
                if (!path) return;
                const img = new Image();
                img.src = `${config.cdnUrl}${basePath}${path}`;
            });
        });
    },

};
